namespace TabAurous.OMS {
    export interface AddressMasterRow {
        AddressId?: number;
        LedgerId?: number;
        AddressType?: string;
        Address1?: string;
        Address2?: string;
        City?: string;
        State?: string;
        Country?: string;
        Pincode?: string;
        CityName?: string;
        StateName?: string;
        CountryName?: string;
        Default?: boolean;
    }

    export namespace AddressMasterRow {
        export const idProperty = 'AddressId';
        export const nameProperty = 'AddressType';
        export const localTextPrefix = 'OMS.AddressMaster';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            AddressId = "AddressId",
            LedgerId = "LedgerId",
            AddressType = "AddressType",
            Address1 = "Address1",
            Address2 = "Address2",
            City = "City",
            State = "State",
            Country = "Country",
            Pincode = "Pincode",
            CityName = "CityName",
            StateName = "StateName",
            CountryName = "CountryName",
            Default = "Default"
        }
    }
}
